"use client";

import * as React from "react";

/**
 * 인덱스 페이지 3컬럼 셸(IndexShell)의 좌/우 사이드바 슬롯을 자식에게 내려주는 Context (JCG-2097).
 *
 * 인덱스 페이지(`/theory`)는 카드 모음이라, 데스크탑에서 일부 카드를 좌/우 사이드바로 분배한다.
 * 셸이 사이드바에 portal 타깃 div 를 두고 그 DOM element 만 Context 로 내려주면, 페이지의 카드
 * 컴포넌트가 `createPortal` 로 자기 자신을 슬롯에 그린다(ArticleShell [D] 의 portal 패턴 동일).
 *
 * - Provider 가 없으면(모바일/태블릿/클래식) 기본값 `inShell:false` → 페이지는 카드를 기존처럼
 *   세로 스택으로 인라인 렌더(폴백). 폴백 시 좌/우 카드는 본문 흐름에 그대로 쌓인다.
 * - 슬롯 element 는 마운트 타이밍 때문에 `useState`(ref 콜백 setter)로 노출한다. 첫 렌더엔 null →
 *   셸 마운트 후 setState → consumer 재렌더 시 portal 그림.
 */
export interface IndexShellSlots {
  /** 셸(데스크탑 인덱스 페이지) 안에서 렌더 중인지 여부 */
  inShell: boolean;
  /** 가운데 컬럼 상단 고정(sticky) 헤더 바 슬롯 — 페이지 타이틀 고정용 (JCG-2097) */
  headerSlot: HTMLElement | null;
  /** 좌측 사이드바 카드 슬롯 (IconRail 옆) */
  leftSlot: HTMLElement | null;
  /** 우측 사이드바 카드 슬롯 */
  rightSlot: HTMLElement | null;
}

const DEFAULT_SLOTS: IndexShellSlots = {
  inShell: false,
  headerSlot: null,
  leftSlot: null,
  rightSlot: null,
};

const IndexShellContext = React.createContext<IndexShellSlots>(DEFAULT_SLOTS);

export function useIndexShell(): IndexShellSlots {
  return React.useContext(IndexShellContext);
}

export default IndexShellContext;
